import FrameTempleSearch from './FrameTempleSearch'

export * from './FrameTempleSearch'

export default FrameTempleSearch
